// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"235":"1f9433c0","696":"1a06c1a1","853":"def5ef1b","884":"b960c543"}[chunkId] + ".js";
};